import { createBlueprint as l } from "@made-people/blueprint";
const t = l({
  slots: {
    base: "flex flex-col pt-4 pb-20 gap-2 lg:h-full lg:p-6 lg:m-0 lg:min-w-[400px] lg:w-[20vw] bg-white overflow-scroll h-[80dvh] max-h-[80dvh] lg:max-h-none",
    searchInputContainer: "flex flex-col gap-2 px-component-spacing-3xl lg:gap-4 lg:mb-4 my-5",
    suggestionlist: "flex flex-col gap-2",
    heading: "",
    suggestionListButton: "",
    closeButton: "w-5",
    productSuggestionList: ""
  },
  variants: {}
});
export {
  t as searchSidebarSuggestionsStyling
};
//# sourceMappingURL=index-blueprint.es.js.map
